import { get, post } from '.';

export function GetAgents(options = {}) {
	return get<any>("/app/api/agents", options);
}

export function CreateAgent(options = {}) {
	return post<any>("/app/api/agents", options);
}
